
import React, { Fragment, useState, useEffect,useRef } from "react";

import { format } from "date-fns";
import { Button, Dropdown } from "react-bootstrap";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
const { config } = require('../api/api');

const MyinsuranceTable = ({ VendorKey,Payload }) => {
  const base_url = config.baseURL;
  const redirectURL = config.redirectURL;
  const lnstr = Cookies.get("langData") ? Cookies.get("langData") : "en";
  const { t } = useTranslation();
  const [insuranceDetails, setInsuranceDetails] = useState([]);
  const [show, setShow] = useState(false);
  const [motorInsStatusShow, setMotorInsStatusShow] = useState(false);
  const [insuranceData, setInsuranceData] = useState(null);
  const [motorInsuranceData, setMotorInsuranceData] = useState(null);
  const itemsPerPage = 10;
  const [totalPages, totalPagess]=useState(0);
  const [profile, setProfile] = useState(null);
  const [indexOfFirstItem, setindexOfFirstItem]= useState(0);
  const [indexOfLastItem, setIndexOfLastItem]= useState(0);
  const [currentItems, currentItemsdata]= useState([]);
  const [currentPage, setCurrentPage] = useState(1);
   const [loading, setLoading] = useState(false);
   const [filter,setFilter]=useState("success");




 const tableRef=useRef(null);
  const [pageChanged,setPageChanged]=useState(false);




  const handleClose = () => {
    setShow(false);
  };
  const handleMotorInsClose = () => {
    setMotorInsStatusShow(false);
  };

    const getButtonClass = (page) =>
    `btn btn-link w-100   text-decoration-none ${
      filter === page ? "btn btn-primary text-light" : "text-dark"
    }`;


  const handleInsuranceData = async (e) => {
    // debugger
    try {
      const policy = { policy_no: e.target.value };
      const response = await fetch(
        `${base_url}/get_personal_accident_policy_details`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${VendorKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(policy),
        }
      );
      if (response.ok) {
        const data = await response.json();
        if (data) {
          setInsuranceData(data.result[0]);
        }
      }
    } catch (err) {
      console.log("Error : " + err);
    }
    setShow(true);
  };

  const handleMotorInsuranceData = async (e) => {
    // debugger
    try {
    const quote_no= e.target.value; 
      
          // setInsuranceData([0]);
        const filtered_policy_data= profile.filter((obj)=>obj.quote_no==quote_no);

        setMotorInsuranceData(filtered_policy_data[0]);
      
    } catch (err) {
      console.log("Error : " + err);
    }
    setMotorInsStatusShow(true);
  };

  

 const handleinsuranceStatus = (policy) => {
    debugger
    const policy_no = policy.policy_no;
    const insurance_type = policy.insurance_type;
    const type = policy.type; // This line might be redundant as it is the same as insurance_type
  
    let page = '';
    if (insurance_type === 'travel' && type === 'inbound') {
      page = `${redirectURL}/download-policy?policyno=${policy_no}`;
      window.open(page, '_blank'); 
    } else if (insurance_type === 'travel' && type === 'outbound') {
      page = `${redirectURL}/download-outbound-policy?policyno=${policy_no}`;
      window.open(page, '_blank'); 
    } else if (insurance_type === 'Personal Accident' && type === 'Personal Accident'
      ) {
      page = `${redirectURL}/personalinformation-downloadpolicy?policyno=${policy_no}`;
      window.open(page, '_blank'); 
    } else if (insurance_type === 'Personal Accident' && type === 'Term Plan') {
      page = `${redirectURL}/termplan-downloadpolicy?policyno=${policy_no}`;
      window.open(page, '_blank'); 
    }else if (insurance_type === 'Life Insurance' && type === 'Personal Accident') {
      page = `${redirectURL}/personalinformation-downloadpolicy?policyno=${policy_no}`;
      window.open(page, '_blank'); 
    } else if (insurance_type === 'Life Insurance' && type === 'Term Plan') {
      page = `${redirectURL}/termplan-downloadpolicy?policyno=${policy_no}`;
      window.open(page, '_blank'); 
    }else if (insurance_type === 'Home Insurance' && type === 'Tenant') {
      page = `${redirectURL}/home-downloadpolicy?policyno=${policy_no}`;
      window.open(page, '_blank'); 
    }else if (insurance_type === 'Home Insurance' && type === 'Owner') {
      page = `${redirectURL}/home-downloadpolicy?policyno=${policy_no}`;
      window.open(page, '_blank'); 
    }
    else if (insurance_type === 'Medical Insurance' && type === 'Individual Medical') {
      page = `${redirectURL}/medical-download?policyno=${policy_no}`;
      window.open(page, '_blank');
    }
    else if (insurance_type === 'Medical Insurance' && type === 'Affordable Health Cover') {
      page = `${redirectURL}/medicalhealth-download?policyno=${policy_no}`;
      window.open(page, '_blank'); 
    }
    else if (insurance_type === 'Medical Insurance' && type === 'Unified Domestic Worker'
      ) {
      page = `${redirectURL}/medicalworker-download?policyno=${policy_no}`;
      window.open(page, '_blank');
    }
  };

   useEffect(()=>{
      if(pageChanged && tableRef.current){
    tableRef.current.scrollIntoView({ behavior: "smooth"});
        }
        else{
          console.log("element not found");
        }
        return ()=>{
          setPageChanged(false);
        }
    },[pageChanged]);

  const calculatePagination = (page,list) => {
    debugger
    const indexOfLastItem = page * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setIndexOfLastItem(indexOfLastItem);
    setindexOfFirstItem(indexOfFirstItem);
    const currentItem = list.slice(indexOfFirstItem, indexOfLastItem);
    currentItemsdata(currentItem);
  };
  
   
  const handleNextPage = () => {
    debugger
    setCurrentPage((prevPage) => {
      const newPage = prevPage < totalPages ? prevPage + 1 : prevPage;
      if(profile.length > 0){
        calculatePagination(newPage,profile);
      }
      return newPage;
    });
  };
  
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => {
      const newPage = prevPage > 1 ? prevPage - 1 : prevPage;
      if(profile.length > 0){
        calculatePagination(newPage,profile);
      }
      // calculatePagination(newPage,insuranceData);
      return newPage;
    });
  };


  const handleMotorInsuranceStatus  =(e,quote_no,payment_status)=>{

    e.preventDefault();

    const token=`3f8d2b7e4c1a9f6b0d2e5a7c8b1f3d9e4a6b7c2d1e9f0a8b3c4d5e6f7a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2c3d4e5f6
`;

const page="/motor-payment-status?sample="+token+"&q_no="+quote_no+"&payment_status="+payment_status;

 window.open(page, '_blank');



  }

  
  const getInsuranceOrders = async () => {
    setLoading(true);
             setCurrentPage(1);
          var get_order_url = base_url+"/get_insurance_details";
          
          debugger
          fetch(get_order_url, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${VendorKey}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(Payload),
          })
            .then(response => response.json())
            .then(data => {
              debugger
              if(data.message==="success"){
            // const testData = Array(15).fill(data.result[0]);
            // data.result = testData;
             if(filter==="success"){
            setLoading(false);

           let filterSuccess= data.result.filter(item => item.payment_status.toLowerCase() === 'success' );

            setProfile(filterSuccess);
             // Set total pages based on data length
        const totalPagesCount = Math.ceil(filterSuccess.length / itemsPerPage);
        totalPagess(totalPagesCount);

        // Initial page calculation
        calculatePagination(1,filterSuccess);
          }
          else if(filter==="pending"){
             setLoading(false);
            const filterPending = data.result.filter(item => {
              if(item.insurance_type && (item.insurance_type.toLowerCase()==="motor insurance" || item.insurance_type.toLowerCase().includes("motor"))){
            return  item.payment_status.toLowerCase() !== 'success' && item.is_deleted === 'no' && item.plan_selection && item.premium_amount
              }
              else{
                return  item.payment_status.toLowerCase() !== 'success' && item.is_deleted === 'no'
              }
            }
             );
            setProfile(filterPending);
             // Set total pages based on data length
        const totalPagesCount = Math.ceil(filterPending.length / itemsPerPage);
        totalPagess(totalPagesCount);

        // Initial page calculation
        calculatePagination(1,filterPending);
          }
          
              }
            })
            .catch(error => {
              console.error('Error fetching countries:', error);
            }).finally(() => {
              setLoading(false)
              });
            }
    useEffect(() => {
  
        // const location  = new URL(window.location.href);
        // const staffid = location.searchParams.get('staff_id');
  
  
        //   var vkData = { token: usrtok, user_type: "agent", staff_id: staffid };
        if(VendorKey ){
          getInsuranceOrders();
        
}
}, [ VendorKey,Payload,filter]);

const handleInsuranceCancel =(e, insurance)=>{
  debugger
  e.preventDefault();
  let payload = {};
  if(insurance.insurance_type && (insurance.insurance_type.toLowerCase()==="motor insurance" || insurance.insurance_type.toLowerCase().includes("motor"))){
  const quote_no = insurance.quote_no;
  payload = { quote_no: quote_no, type:"motor insurance" };
  }
  else{
    const policy_no = insurance.policy_no;
    payload = { policy_no: policy_no, type:"insurance" };
  }
  setLoading(true);
     fetch(base_url+"/insurance_order_cancel",{
          method:"POST",
          headers:{
            "Authorization":"Bearer "+VendorKey,
            "Content-Type":"application/json"
          },
          body:JSON.stringify(payload)
        }).then((response)=>response.json())
        .then((data)=>{
          if(data.message==="success"){
            //  setFilter("pending");
             getInsuranceOrders();
          }
        }).catch(err=>console.error("while updating insurance cancel err : "+err))
        .finally(() => {
          setLoading(false);
        }); 
}



const handlePaymentTrigger =async (e, insurance)=>{
  debugger
  e.preventDefault();
  let payload = {};
  let path="";
  const ins_type =insurance.insurance_type?insurance.insurance_type.toLowerCase():"";

  // motor insurance
  if(ins_type && (ins_type==="motor insurance" || ins_type.includes("motor"))){

  const quote_no = insurance.quote_no;
  path = "/motor_payments";
  payload = { quoteNo: quote_no, srcBusId:"SJET" };

  }

  if(!path){
    return;
  }
  setLoading(true);
     fetch(base_url+path, {
          method:"POST",
          headers:{
            "Authorization":"Bearer "+VendorKey,
            "Content-Type":"application/json"
          },
          body:JSON.stringify(payload)
        }).then((response)=>response.json())
        .then((data)=>{
          if(data.message==="success"){
            //  setFilter("pending");
 if (data.message === "success" && ins_type && (ins_type === "motor insurance" || ins_type.includes("motor"))) {
      const payment_link = data.result.transactionDetails.pgUrl;
      const anchor = document.createElement("a");
      anchor.setAttribute("href", payment_link);
     
      anchor.click();
    } 
     }
        }
      ).catch(err=>console.error("while updating insurance cancel err : "+err))
        .finally(() => {
          setLoading(false);
        }); 
}


  return (
    <>
      {/* <div className="header_section1">
        

        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">
              {t("MY")} {t("INSURANCE")}
            </h3>
          </div>
        </div>
      </div> */}

      <div className="features_section  my-1">
        <div className="container">
              <div className="row  d-flex justify-content-end">
           
                
                <div className="col-lg-4 col-md-6 pt-5">
                  <div className="w-100 orders-table">    
                <ul className={`list-unstyled mb-0 p-0 d-flex justify-content-end ${lnstr=="ar"?"mr-3":"ml-3"}`}>
                  <li  style={{ 
                    // flex: "1 1 0", /* grow, shrink, basis */
          textAlign: "center",
          border: "1px solid #ccc",
          // borderTopLeftRadius:"5px",
          // borderBottomLeftRadius:"5px",
         backgroundColor:filter==="success"?"#3fd2f2":"",
          //  borderRadius:"20px 0px 0px 20px"
          }}>
                    <button
                      className={getButtonClass("success")}
                      style={{ fontSize: "18px",textAlign:"center",  borderRadius:"20px 0px 0px 20px" }}
                      onClick={(e) => {e.preventDefault(); setFilter("success")}}
                    >
                      {t("Success")}
                    </button>
                  </li>
                  <li   style={{ 
                    // flex: "1 1 0", /* grow, shrink, basis */
          textAlign: "center",
          border: "1px solid #ccc",
          backgroundColor:filter==="pending"?"#3fd2f2":"",
          // borderRadius:"0px 20px 20px 0px"
         }}>
                    <button
                      className={getButtonClass("pending")}
                      style={{ fontSize: "18px" ,textAlign:"center",  borderRadius:"0px 20px 20px 0px"}}
                      onClick={(e) => {e.preventDefault();  setFilter("pending")}}
                    >
                      {t("Pending")}
                    </button>
                  </li>
                </ul>
                </div>
        
               
             
        </div>
        </div>
          <div className="row g-4 justify-content-center">
            <div className="col-12 wow fadeInUp" data-wow-delay="0.2s" style={{ overflowX: 'auto' }}>

       <div className="orders-table" ref={tableRef}>     
            <table className="table table-bordered mt-3">
              <thead>
                <tr>
                  <th>#</th>
                  <th>
                    {t("Full Name")}
                  </th>
                
                  <th>{t("Email")}</th>
                  <th>
                    {t("Mobile")}
                    {t("No")}
                  </th>
                  <th>{t("Passport")}</th>
                  <th>
                    {t("Policy")}
                    {t("No")}
                  </th>
                  <th>{t("Payment Status")}</th>
                 
                      <th>{t("View")}</th>
                  
                  {
                    filter === "success" ?
                      <th>{t("Download")}</th>
                      :<></>
                 }
                 {
                    filter === "pending" ?
                    <th colSpan={2} style ={{textAlign:"center"}}>{t("Action")}</th>
                    :<></>
                 }
                </tr>
              </thead>
              <tbody>

                { insuranceDetails.length <=0 && currentItems.length <= 0 && (
                  <tr>
                    <td colSpan={9} className="textcenter" style={{ textAlign: 'center', verticalAlign: 'middle' }}>{t('No')} {t('Records')} {t('Found')}</td>
                  </tr>
                )}

                    {currentItems .length >0 && currentItems?.map((insurance, index) => {
                  return (
                    insurance.insurance_type==="Motor Insurance"?
                    <tr key={index}>
                      <td>{indexOfFirstItem + index + 1}</td>
                      <td>{insurance.first_name} {insurance.last_name}</td>
                      <td>{JSON.parse(insurance.communication_preferences)?.emailId || "-"}</td>
                      <td>{JSON.parse(insurance.communication_preferences)?.mobileNo || "-"}</td>
                      <td>{insurance.passport || "N/A"}</td>
                      <td>{insurance.policy_no}</td>
                      <td>{insurance.payment_status}</td>
                     
                      <td>
                        <Button
                          variant="primary"
                          style={{ fontWeight: "normal" }}
                          className="btn btn-primary rounded-pill text-white py-1 px-2"
                          onClick={handleMotorInsuranceData}
                          value={insurance.quote_no}
                        >
                          {t("View")}
                        </Button>
                      </td>
                        {
                    filter === "success" ?
                      <td>
                        
                         <Button variant="primary" style={{ fontWeight: 'normal' }}
                                           className="btn btn-primary rounded-pill text-white py-1 px-2"
                                           onClick={(e) => handleMotorInsuranceStatus(e,insurance.quote_no,insurance.payment_status)} // Use onClick and pass `prof`
                                           value={insurance.policy_no}
                                         >
                                           {t('Download')}
                                         </Button>
                          </td>
                          :
                            <td>
                                        <Button variant="primary" style={{ fontWeight: 'normal' }}
                                           className="btn btn-primary rounded-pill text-white py-1 px-2"
                                           onClick={(e) => handlePaymentTrigger(e,insurance)} // Use onClick and pass `prof`
                                           value={insurance.policy_no}
                                         >
                                           {t('Pay')}
                                         </Button>
                            </td>
                    }

                          {/* {
                            filter === "pending" ?
                           :<></>
                          } */}
                          {
                            filter === "pending" ?
                            <td>
                                        <Button variant="primary" style={{ fontWeight: 'normal' }}
                                           className="btn btn-primary rounded-pill text-white py-1 px-2"
                                           onClick={(e) => handleInsuranceCancel(e,insurance)} // Use onClick and pass `prof`
                                           value={insurance.policy_no}
                                         >
                                           {t('Cancel')}
                                         </Button>
                                         
                             </td>:<></>
                          }

                    </tr>
                    :
                    <tr key={index}>
                      <td>{indexOfFirstItem + index + 1}</td>
                      <td>{insurance.first_name} {insurance.last_name}</td>
                      <td>{insurance.email}</td>
                      <td>{insurance.mobile_no}</td>
                      <td>{insurance.passport}</td>
                      <td>{insurance.policy_no}</td>
                      <td>{insurance?.payment_status}</td>
                       <td>
                        <Button
                          variant="primary"
                          style={{ fontWeight: "normal" }}
                          className="btn btn-primary rounded-pill text-white py-1 px-2"
                          onClick={handleInsuranceData}
                          value={insurance.policy_no}
                        >
                          {t("View")}
                        </Button>
                      </td>
                    {
                    filter === "success" ?
                    <> 
                    
                      <td>
                        
                         <Button variant="primary" style={{ fontWeight: 'normal' }}
                                           className="btn btn-primary rounded-pill text-white py-1 px-2"
                                           onClick={() => handleinsuranceStatus(insurance)} // Use onClick and pass `prof`
                                           value={insurance.policy_no}
                                         >
                                           {t('Download')}
                                         </Button>
                          </td>
                          </>:
                          <> 
                    
                      <td>
                        
                         <Button variant="primary" style={{ fontWeight: 'normal' }}
                                           className="btn btn-primary rounded-pill text-white py-1 px-2"
                                           onClick={() => handleinsuranceStatus(insurance)} // Use onClick and pass `prof`
                                           value={insurance.policy_no}
                                         >
                                           {t('Pay')}
                                         </Button>
                          </td>
                          </>
                          }
{/* {
  filter === "pending" ?
  <td>
                                        <Button variant="primary" style={{ fontWeight: 'normal' }}
                                           className="btn btn-primary rounded-pill text-white py-1 px-2"
                                            onClick={(e) => handlePaymentTrigger(e,insurance)} // Use onClick and pass `prof`
                                           value={insurance.policy_no}
                                         >
                                           {t('Pay')}
                                         </Button>
  </td>:<></>
} */}
{
  filter === "pending" ?
  <td>
                                        <Button variant="primary" style={{ fontWeight: 'normal' }}
                                           className="btn btn-primary rounded-pill text-white py-1 px-2"
                                          onClick={(e) => handleInsuranceCancel(e,insurance)}
                                           value={insurance.policy_no}
                                         >
                                           {t('Cancel')}
                                         </Button>
                                         
  </td>:<></>
}


                    </tr>
                    
                  );
                })}
                
              </tbody>
            </table>
</div>
            {totalPages === 0 ? <div></div> : <div className="pagination-controls-new">
                <button onClick={handlePrevPage} disabled={currentPage === 1}>
                  ‹
                </button>
                <span>

                </span>
                <span>
                  {t('Page')} {currentPage} {t('of')} {totalPages}
                </span>
                <span>

                </span>
                <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                  ›
                </button>
              </div>}
            </div>
          </div>
        </div>
      </div>

     
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
      {show && (
        <div className="modal">
          <div
            className="modal-content"
            style={{ height: "525px", width: "700px" }}
          >
            <h2>
              <span>
                {t("Insurance")} {t("Status")}
              </span>
            </h2>
            <button type="button" className="close" onClick={handleClose}>
              &times;
            </button>
            <div style={{ height: "50px" }}></div>
            <div className="d-flex justify-content-center">
              <table style={{  width: "250" }}>
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Full Name")}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{insuranceData?.first_name} {insuranceData?.last_name}</b>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Email")}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{insuranceData?.email}</b>
                  </td>
                </tr>
                {/* <tr>
              <td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Date Of Birth')} </td>
              <td style={{ fontWeight: 'bold', textAlign:'left'}}>:
                </td><td style={{textAlign:'left'}}><b>{insuranceData?.policy_data?.dob}</b></td>
                </tr>
                <tr>
              <td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Gender')} </td>
              <td style={{ fontWeight: 'bold', textAlign:'left'}}>:
                </td><td style={{textAlign:'left'}}><b>{insuranceData?.policy_data?.inbound_gender_detail}</b></td>
                </tr> */}
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Mobile")} {t("No")}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{insuranceData?.mobile_no}</b>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Passport")} {t("No")}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{insuranceData?.passport}</b>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Policy")} {t("No")}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{insuranceData?.policy_no}</b>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {" "}
                    {t("Status")}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{insuranceData?.status}</b>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Fee")}{" "}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>
                      {insuranceData?.fee ? `${insuranceData?.fee} OMR` : ""}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Payment")} {t("Status")}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{insuranceData?.payment}</b>
                  </td>
                </tr>

                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Insurance")}{" "}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{insuranceData?.insurance_type}</b>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Insurance")} {t("Type")}{" "}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{insuranceData?.type}</b>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Created Date")}{" "}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{insuranceData?.created_at.replace("T","   ").replace(".000Z","")}</b>
                  </td>
                </tr>
              </table>

           
            </div>
            <div>
                 <button
                type="button"
                class="btn btn-sm btn-close d-none d-md-inline-block"
                aria-label="Close"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

           {motorInsStatusShow && (
        <div className="modal">
          <div
            className="modal-content"
            style={{ height: "525px", width: "700px" }}
          >
            <h2>
              <span>
                {t("Insurance")} {t("Status")}
              </span>
            </h2>
            <button type="button" className="close" onClick={handleMotorInsClose}>
              &times;
            </button>
            <div style={{ height: "50px" }}></div>
            <div>
              <table style={{ marginLeft: "65px", width: "250" }}>
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Full Name")}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{motorInsuranceData?.first_name} {motorInsuranceData?.last_name}</b>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Email")}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{JSON.parse(motorInsuranceData.communication_preferences)?.emailId || "-"}</b>
                  </td>
                </tr>
                {/* <tr>
              <td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Date Of Birth')} </td>
              <td style={{ fontWeight: 'bold', textAlign:'left'}}>:
                </td><td style={{textAlign:'left'}}><b>{motorInsuranceData?.policy_data?.dob}</b></td>
                </tr>
                <tr>
              <td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Gender')} </td>
              <td style={{ fontWeight: 'bold', textAlign:'left'}}>:
                </td><td style={{textAlign:'left'}}><b>{motorInsuranceData?.policy_data?.inbound_gender_detail}</b></td>
                </tr> */}
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Mobile")} {t("No")}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{JSON.parse(motorInsuranceData.communication_preferences)?.mobileNo || "-"}</b>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Quote")} {t("No")}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{motorInsuranceData?.quote_no}</b>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Policy")} {t("No")}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{motorInsuranceData?.policy_no}</b>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {" "}
                    {t("Status")}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{motorInsuranceData?.status}</b>
                  </td>
                </tr>
                  <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Product")}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>
                      {motorInsuranceData?.product_id}
                    </b>
                  </td>
                </tr>
                 <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Plan")}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>
                      {motorInsuranceData?.plan_selection}
                    </b>
                  </td>
                </tr>
                
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Premium")}{" "}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>
                      {motorInsuranceData?.premium_amount ? `${motorInsuranceData?.premium_amount} OMR` : ""}
                    </b>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Payment")} {t("Status")}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{motorInsuranceData?.payment_status}</b>
                  </td>
                </tr>

                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Insurance")}{" "}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{motorInsuranceData?.insurance_type}</b>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>
                    {t("Created Date")}{" "}
                  </td>
                  <td style={{ fontWeight: "bold", textAlign: "left" }}>&nbsp;:&nbsp;</td>
                  <td style={{ textAlign: "left" }}>
                    <b>{motorInsuranceData?.created_at.replace("T","   ").replace(".000Z","")}</b>
                  </td>
                </tr>
              </table>

              <button
                type="button"
                class="btn btn-sm btn-close d-none d-md-inline-block"
                aria-label="Close"
                onClick={handleMotorInsClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default MyinsuranceTable;
